<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="tuitionPeriods"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    :loading="loading"
    outlined
    dense
    return-object
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { TuitionFeePeriod } from '@/plugins/api'
import { sortPeriod } from '../../../modules/tuitionFee/head-fee/helper/period'

export default {
  data: () => ({
    tuitionPeriods: [],
    loading: false
  }),
  props: {
    filter: Object,
    defaultDivisions: Object,
    options: Object
  },
  computed: {
    ...mapGetters('app', ['currentSchoolYear'])
  },
  created() {
    if (this.defaultDivisions) {
      this.tuitionPeriods = this.defaultDivisions
    }

    this.fetchAllTuitionPeriods()
  },
  methods: {
    async fetchAllTuitionPeriods() {
      this.loading = true
      let tuitionPeriods = await TuitionFeePeriod.fetch({
        ...this.filter,
        _limit: -1
      })
      tuitionPeriods = sortPeriod(tuitionPeriods).map(p => {
        if (
          p.title.includes('7') ||
          p.title.includes('8') ||
          p.title.includes('9') ||
          p.title.includes('10') ||
          p.title.includes('11') ||
          p.title.includes('12')
        ) {
          p.title = p.title + ' / ' + this.currentSchoolYear.code
        } else {
          p.title = p.title + ' / ' + (+this.currentSchoolYear.code + 1)
        }

        return p
      })
      this.tuitionPeriods = tuitionPeriods
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filter(filter) {
      this.fetchAllTuitionPeriods()
    }
  }
}
</script>

<style scoped></style>
